/* eslint-disable no-nested-ternary */
import { useState, useEffect } from 'react';
import { Modal, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import CloseButtonIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

import { themeColors } from '../../../utils/theme';
import useResponsive from '../../../utils/responsive';

const Popup = (props) => {
    const { children, isOpen, onClose } = props;
    const { isMobile, isTablet } = useResponsive();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

    const handleClose = () => {
        setOpen(false);
        if (onClose) {
            onClose();
        }
    };

    const id = open ? 'promotional-popover' : undefined;
    const modalClassName = isMobile ? 'modal-content-mobile' : isTablet ? 'modal-content-tablet' : 'modal-content';
    const modelCloseButtonClassName = isMobile ? 'modal-content-mobile-close-button' : isTablet ? 'modal-content-tablet-close-button' : 'modal-content-close-button';

    return (
        <Modal
            id={id}
            open={open}
            onClose={handleClose}
            aria-labelledby="promotional-modal"
            aria-describedby="promotional-modal-details"
        >
            <div className={modalClassName}>
                <IconButton
                    className={modelCloseButtonClassName}
                    disableRipple
                    aria-label="close"
                    onClick={handleClose}
                >
                    <CloseButtonIcon style={{ color: '#B9B9B9' }} />
                </IconButton>
                {children}
            </div>
        </Modal>
    );
};

export default Popup;

Popup.propTypes = {
    isOpen: PropTypes.bool,
    children: PropTypes.any,

    onClose: PropTypes.func,
};

